import { CLIENTS } from "@/data/content";

export const ClientMarquee = ({ outline = false, speed = "normal", clients }) => {
    const base = clients && clients.length ? clients : CLIENTS;
    const list = [...base, ...base];
    const speedClass = speed === "slow" ? "marquee-track-slow" : "marquee-track";

    return (
        <div className="overflow-hidden">
            <div className={`flex gap-16 whitespace-nowrap ${speedClass}`}>
                {list.map((c, i) => (
                    <span
                        key={`${c}-${i}`}
                        className={`font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter shrink-0 ${
                            outline ? "outline-text" : "text-brand-mist"
                        }`}
                    >
                        {c}
                        <span className="text-brand-primary mx-6">●</span>
                    </span>
                ))}
            </div>
        </div>
    );
};
